(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["adenos-mega-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('adn-mega-navigation')) {
  customElements.define('adn-mega-navigation', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.frame = requestAnimationFrame(() => this.setup());
    }
    setup() {
      this.wrapper = this.closest('.header-wrapper');
      if (!this.wrapper) return;
      const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z]/g, '');
      this.link = [...this.wrapper.querySelectorAll('.header__inline-menu > ul > li > a')].find(link => /^complements?alimentaires?$/.test(normalize(link.textContent)));
      if (!this.link) return;
      this.parent = this.link.parentElement;
      this.parent.classList.add('adn-mega-parent');
      if (getComputedStyle(this.wrapper).position === 'static') this.wrapper.classList.add('adn-mega-positioned');
      this.panel = this.querySelector('.adn-mega-panel');
      this.panel.id = 'AdnMega-' + (this.wrapper.closest('.shopify-section')?.id || 'header');
      this.button = document.createElement('button');
      this.button.type = 'button';
      this.button.className = 'adn-mega-toggle';
      this.button.setAttribute('aria-label', 'Afficher les gammes de compléments alimentaires');
      this.button.setAttribute('aria-expanded', 'false');
      this.button.setAttribute('aria-controls', this.panel.id);
      this.button.innerHTML = '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="m3 6 5 5 5-5" stroke="currentColor" stroke-width="1.5"/></svg>';
      this.link.after(this.button);
      this.desktop = matchMedia('(min-width: 990px)');
      const on = (el, event, callback) => el.addEventListener(event, callback, {signal: this.controller.signal});
      const enter = event => { if (event.pointerType === 'mouse') this.show(); };
      const leave = () => { clearTimeout(this.timer); this.timer = setTimeout(() => { if (!this.panel.contains(document.activeElement) && document.activeElement !== this.button) this.close(); }, 220); };
      on(this.parent, 'pointerenter', enter);
      on(this.parent, 'pointerleave', leave);
      on(this.panel, 'pointerenter', enter);
      on(this.panel, 'pointerleave', leave);
      on(this.button, 'click', () => this.hasAttribute('open') ? this.close() : this.show());
      on(this.button, 'keydown', event => {
        if ((event.key === 'Tab' && !event.shiftKey && this.hasAttribute('open')) || event.key === 'ArrowDown') {
          event.preventDefault(); this.show(); this.panel.querySelector('a').focus();
        }
      });
      on(this.panel, 'keydown', event => {
        const links = [...this.panel.querySelectorAll('a')];
        if (event.key === 'Tab' && event.shiftKey && document.activeElement === links[0]) { event.preventDefault(); this.button.focus(); }
        else if (event.key === 'Tab' && !event.shiftKey && document.activeElement === links.at(-1)) {
          const targets = [...this.wrapper.querySelectorAll('a[href], button, summary, input')].filter(el => el.getClientRects().length && !el.closest('adn-mega-navigation') && !el.disabled && el.tabIndex >= 0);
          const next = targets[targets.indexOf(this.button) + 1];
          if (next) { event.preventDefault(); next.focus(); } this.close();
        }
      });
      on(document, 'keydown', event => { if (event.key === 'Escape' && this.hasAttribute('open')) { this.close(); this.button.focus(); } });
      on(document, 'pointerdown', event => { if (!this.parent.contains(event.target) && !this.contains(event.target)) this.close(); });
      on(document, 'focusin', event => { if (!this.parent.contains(event.target) && !this.contains(event.target)) this.close(); });
      on(this.desktop, 'change', () => this.close());
      on(window, 'scroll', () => this.close());
      this.wrapper.querySelectorAll('.header__inline-menu > ul > li').forEach(item => {
        if (item !== this.parent) on(item, 'pointerenter', () => this.close());
      });
    }
    show() {
      if (!this.desktop.matches) return;
      clearTimeout(this.timer);
      this.wrapper.querySelectorAll('header-menu details[open]').forEach(details => details.removeAttribute('open'));
      this.setAttribute('open', ''); this.panel.inert = false; this.button.setAttribute('aria-expanded', 'true');
    }
    close() {
      clearTimeout(this.timer); this.removeAttribute('open');
      if (this.panel) this.panel.inert = true;
      this.button?.setAttribute('aria-expanded', 'false');
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame); clearTimeout(this.timer); this.controller?.abort();
      this.button?.remove(); this.parent?.classList.remove('adn-mega-parent');
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
